import { inject, Injectable } from '@angular/core';
import { IUseCase } from '@core/base/use-case.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IProfileForm } from '../interfaces/profile-form.interface';
import { ProfileFormToApiMapperService } from '../mappers/profile-form-to-api-mapper.service';
import { IVdoApiSimpleResponse } from '@core/interfaces/api/vdo-api-response.interface';
import { FtsUsersApiService } from '@core/services/api/fts-users.api.service';
import { UserSessionStorageService } from '@core/services/user-session-storage.service';

@Injectable()
export class ProfileUpdateUseCaseService implements IUseCase<IProfileForm, IVdoApiSimpleResponse> {
  private readonly profileApiService = inject(FtsUsersApiService);
  private readonly userSessionStorageService = inject(UserSessionStorageService);
  private readonly formToApiMapper = inject(ProfileFormToApiMapperService);

  execute(data: IProfileForm): Observable<IVdoApiSimpleResponse> {
    const payload = this.formToApiMapper.mapTo(data);
    return this.profileApiService.updateProfile(payload).pipe(
      tap(() => {
        this.userSessionStorageService.updateProfileName(data.name);
      })
    );
  }
}
